import { render, staticRenderFns } from "./KickstartComplate.vue?vue&type=template&id=05c703da"
import script from "./KickstartComplate.vue?vue&type=script&lang=js"
export * from "./KickstartComplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports